"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    line: function line(_ref) {
      var width = _ref.width;
      return {
        backgroundColor: 'var(--Timber-Wolf-50)',
        width: width
      };
    }
  };
});

var Line = function Line(_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 'auto' : _ref2$width,
      dividerProps = (0, _objectWithoutProperties2["default"])(_ref2, ["width"]);
  var classes = useStyles({
    width: width
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Divider, (0, _extends2["default"])({
    className: classes.line
  }, dividerProps));
};

var _default = Line;
exports["default"] = _default;